import { Injectable, inject } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { AngularPlugin } from '@microsoft/applicationinsights-angularplugin-js';
import { default as config } from '../../../appsettings.json';
import { Router } from '@angular/router';
@Injectable({
  providedIn: 'root',
})
export class ApplicationInsightService {
  private router = inject(Router);

  appInsights: ApplicationInsights;

  trackPageView() {
    return;
    this.appInsights.trackPageView();
  }

  logError(error: Error) {
    return;
    this.appInsights.trackException({ exception: error });
  }
}
